import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(2%)
  }
  to {
    opacity: 1;
    transform: translateY(0)
  }
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 20px 0;
  animation: ${fadeIn} 500ms ease-in-out;
`;

export const ImageWrapper = styled.div`
  height: 100%;
  .gatsby-image-wrapper {
    height: 100%;
  }
`;

export const ImageWrapperFull = styled(ImageWrapper)`
  overflow: hidden;
  .gatsby-image-wrapper {
    transform: scale(1.2);
  }
`;

export const Block = styled.div`
  background-color: ${({ color }: { color: string }) => color};
  width: ${({ size }: { size: number }) => size}%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`;

interface TextProps {
  color: string;
  titleColor: string;
}

function mainColor({ titleColor }: TextProps) {
  return titleColor ? titleColor : "black";
}

export const Text = styled.div`
  font-family: Fira Sans;
  font-weight: 300;
  padding: 70px;
  color: ${({ color }: TextProps) => color};
  h2 {
    margin: 0;
    color: ${({ titleColor }: TextProps) => titleColor};
  }
  a {
    text-decoration: underline;
  }

  a.button {
    text-decoration: none;
    border: solid 1px ${mainColor};
    color: ${mainColor};
    padding: 10px 20px;
    text-transform: uppercase;
    background-color: transparent;
    font-family: Fira Sans;
    position: relative;
    z-index: 0;
    transition: 150ms;
    margin: 20px 0;
    display: table;

    &:before {
      content: "";
      position: absolute;
      width: 0;
      height: 100%;
      background-color: ${({ titleColor }: TextProps) =>
        titleColor ? titleColor : "black"};
      display: block;
      top: 0;
      left: 50%;
      z-index: -1;
      transition: 250ms;
      opacity: 0;
    }

    &:hover {
      color: white;
      box-shadow: 0 0 1px rgba(34, 25, 25, 0.4);
      border-radius: 3px;
      padding: 10px 25px;
      &:before {
        width: 100%;
        left: 0;
        opacity: 1;
      }
    }
  }
  ul {
    list-style-type: none;
    padding: 0;

    li {
      &:before {
        content: "-";
        margin-right: 10px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 30px;
  }
`;
